import { InfoCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { HINT_TOOLTIP_STYLES } from "constants/ui";

/**
 * FilterFieldLabel - Small label shown above a filter control inside the
 * filters drawer. Keeps label styling consistent across all filter components.
 * Optional `hint` renders an info tooltip next to the label.
 */
const FilterFieldLabel = ({ label, hint }) => {
  if (!label) return null;
  return (
    <p className="text-[13px] font-medium text-text-body mb-2 flex items-center gap-1">
      {label}
      {hint && (
        <Tooltip title={hint} placement="top" styles={HINT_TOOLTIP_STYLES}>
          <InfoCircleOutlined className="text-info-icon cursor-pointer text-[13px] hover:text-info-icon-hover transition-colors" />
        </Tooltip>
      )}
    </p>
  );
};

export default FilterFieldLabel;
